import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Swal from 'sweetalert2';
import * as Sentry from '@sentry/react';
import cartUtils from '../../../utils/cart';
import { getStudents } from '../../../actions/action_parent';
import { setAdditionalData } from '../../../reducers/additionalDataSlice';
import { getGalleries } from '../../../actions/action_gallery';
import {
  getShootData,
  formatAndSetBackgroundOptions,
  formatAndSetIncentiveProducts,
  setInterstitialProducts,
  setPreCartOfferProducts,
  setRetouchingProduct,
  setRetouchingProducts,
  setPersonalizationProduct,
  setTriggersPreCartOfferProducts,
} from '../../../actions/action_shoot';
import {
  getBnlKeyLookup,
  getBnlKeyLookupWithSelectedEvent,
  getBnlKeyLookupWithSelectedGallery,
  setBnlPreShoot,
  setBnlPreShootOrderContext,
  setEnteredKeyIsPrepay,
} from '../../../actions/action_bnl_pre_shoot';
import { updateOrderActiveComponent } from '../../../actions/action_order_navigation';
import { storeOrder } from '../../../actions/action_cart';

// React.js components
import BnlParentGalleryKeyForm from './bnl_parent_gallery_key_form';
import BnlDashboardNotice from './bnl_dashboard_notice';
import UnsubscribeBanner from '../../v3/banner/UnsubscribeBanner';

import DashboardGalleries from './../../v3/dashboard/DashboardGalleries';
import MyRegistrations from '../../event-registration/MyRegistrations';
import {
  buildGalleryOrderContext,
  buildGalleryOrderShootData,
  findDashboardGalleryForOrder,
} from '../../v3/dashboard/galleryOrderContext';
import seasonLabel from '../../../utils/seasonLabel';

// Shared by every action button in the decision modal, so the prepay option
// and the gallery options read as the same kind of choice.
const DECISION_MODAL_BUTTON_STYLE = `
  background-color: #ffffff;
  border: 1px solid #000000;
  padding: 10px 16px;
  border-radius: 4px;
  color: #000000;
  font-weight: 500;
  width: 100%;
  margin-top: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

const DECISION_MODAL_BUTTON_HOVER = `
  onmouseover="this.style.backgroundColor='#000000'; this.style.color='#ffffff';"
  onmouseout="this.style.backgroundColor='#ffffff'; this.style.color='#000000';"
`;

// The prepay button is the call to action on a prepay event, so it takes the
// Pics primary blue (v3 PrimaryButton) instead of the outlined gallery style.
const PREPAY_BUTTON_STYLE = `
  ${DECISION_MODAL_BUTTON_STYLE}
  background-color: #0b76b7;
  border: 1px solid #0b76b7;
  color: #ffffff;
  font-weight: 700;
`;

const PREPAY_BUTTON_HOVER = `
  onmouseover="this.style.backgroundColor='#357abd'; this.style.borderColor='#357abd';"
  onmouseout="this.style.backgroundColor='#0b76b7'; this.style.borderColor='#0b76b7';"
`;

// Stands in for the gallery thumbnail on a prepay event, which has no images yet.
const seasonTileHtml = (shootDate) => {
  const season = seasonLabel(shootDate);

  return `
    <div style="
      width: 100px;
      height: 125px;
      box-sizing: border-box;
      padding: 8px 6px;
      border-radius: 4px;
      background-color: #1f1f1f;
      color: #ffffff;
      text-align: center;
      line-height: 1.2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
    ">
      <div style="font-size: 26px;">📸</div>
      <div style="font-size: 9px; letter-spacing: 0.5px; text-transform: uppercase;">
        Picture Day
      </div>
      ${
        season
          ? `<div style="font-size: 15px; font-weight: 700;">${season}</div>`
          : ''
      }
    </div>
  `;
};

export class BnlParentDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeComponent: 1,
      editGallery: false,
      editingStudentId: null,
      galleryKey: props.location.state?.key
        ? props.location.state.key
        : new URLSearchParams(props.location.search).get('key') ||
          sessionStorage.getItem('dashboard_gallery_key') ||
          '',
      getStudentsCalled: false,
      loading: false,
      selectedStudent: null,
      domLoaded: false,
      presetEventKey: false,
      requiresTermsConditions: false,
      keyLookupData: null,
    };

    this.STEPS = {
      dashboard: 1,
      studentSelection: 2,
    };

    this.goToStudentSelection = this.goToStudentSelection.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.toggleEditGallery = this.toggleEditGallery.bind(this);
    this.handleDomLoaded = this.handleDomLoaded.bind(this);
    this.handleGpiSelectPrepayEvent =
      this.handleGpiSelectPrepayEvent.bind(this);
    this.handleGpiAddGalleryToDashboard =
      this.handleGpiAddGalleryToDashboard.bind(this);
    this.handleGpiOrderFromGallery = this.handleGpiOrderFromGallery.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const that = this;
    // // redirect to signup step 2 when directly accessing "/dashboard" URL
    // // if current user is truthy but hasn't completed signup
    if (nextProps.auth.currentUserId && !nextProps.auth.signupCompleted) {
      this.props.history.replace('/signup', { step: 2 });
    } else if (
      this.props.orderNavigation.step === null &&
      nextProps.orderNavigation.step === null
    ) {
      this.setState({ activeComponent: this.STEPS.dashboard });
    }
  }

  componentDidMount() {
    // TODO: check for T&C terms here
    axios
      .get('/api/v2/parents/check-tc')
      .then((response) => {
        const requireTerms = response.data.requires_user_to_accept_terms;
        const termsAccepted = response.data.terms_accepted;

        if (requireTerms && !termsAccepted) {
          this.setState({ requiresTermsConditions: true });
        } else {
          this.setState({ requiresTermsConditions: false });
        }
      })
      .catch((error) => console.error('Error checking T&C:', error));

    // TODO: we should move this call somewhere else... it's a bit hacky
    this.getStudents(this.props.auth.currentUserId);

    const eventKey = Cookies.get('pics_event_key');
    const productKey = Cookies.get('product_key');
    const campaignEventId = Cookies.get('campaign_event_id');

    if (eventKey && eventKey !== '') {
      this.setState({ galleryKey: eventKey, presetEventKey: true });
      sessionStorage.setItem('dashboard_gallery_key', eventKey);
      Cookies.remove('pics_event_key');
    } else {
      const urlParams = new URLSearchParams(this.props.location.search);
      const urlKey = urlParams.get('key');
      const storedKey = sessionStorage.getItem('dashboard_gallery_key');
      if (urlKey) {
        this.setState({ galleryKey: urlKey, presetEventKey: true });
        sessionStorage.setItem('dashboard_gallery_key', urlKey);
      } else if (storedKey) {
        this.setState({ galleryKey: storedKey, presetEventKey: true });
      }
    }

    if (Object.keys(this.props.cart.orders).length === 0) {
      this.props.setBnlPreShoot(null);
    }

    this.props.updateOrderActiveComponent(null);
    window.scrollTo(0, 0);

    this._ismounted = true;
    window.addEventListener('load', this.handleDomLoaded);

    // hack to clear edit configuration when user navigates from edit to dashboard
    const { orders } = this.props.cart;

    for (const studentId in orders) {
      const orderState = orders[studentId];
      orderState.editingFromCart = false;
      orderState.bnlEditConfiguration = null;

      this.props.storeOrder(studentId, orderState);
    }

    if (eventKey && productKey && campaignEventId) {
      this.goToStudentSelection(eventKey);
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  handleDomLoaded() {
    if (this._ismounted) {
      this.setState({ domLoaded: true });
    }
  }

  handleOnChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.goToStudentSelection();
    }
  }

  parentHasAtLeastOneStudent() {
    if (typeof this.props.parent.students === 'undefined') {
      return false;
    }

    return this.props.parent.students.length > 0;
  }

  toggleEditGallery(studentId) {
    this.setState({
      editGallery: !this.state.editGallery,
      editingStudentId: studentId,
    });
  }

  formatBackgroundOptions(containsBackgroundCategories, backgroundOptions) {
    const formattedBackgroundOptions = {};

    if (containsBackgroundCategories) {
      backgroundOptions.forEach((backgroundSet) => {
        backgroundSet.background_images.forEach((backgroundOption) => {
          formattedBackgroundOptions[backgroundOption.id] = backgroundOption;
        });
      });
    } else {
      backgroundOptions.forEach((backgroundOption) => {
        formattedBackgroundOptions[backgroundOption.id] = backgroundOption;
      });
    }

    this.props.formatAndSetBackgroundOptions(formattedBackgroundOptions);
  }

  formatIncentiveProducts(incentiveProducts) {
    const formattedIncentiveProducts = {};

    incentiveProducts.forEach((incentiveProduct) => {
      if (!formattedIncentiveProducts[incentiveProduct.incentive_threshold]) {
        formattedIncentiveProducts[incentiveProduct.incentive_threshold] = [];
      }

      formattedIncentiveProducts[incentiveProduct.incentive_threshold].push(
        incentiveProduct,
      );
    });

    this.props.formatAndSetIncentiveProducts(formattedIncentiveProducts);
  }

  getStudents(currentUserId) {
    const that = this;

    this.props.getStudents(currentUserId).then((response) => {
      if (that.parentHasAtLeastOneStudent()) {
        const { students } = this.props.parent;
        const student_ids = students.map((student, i) => student.id);
        that.props.getGalleries({ student_ids });
      }
    });
  }

  goToStudentSelection(eventKey = null) {
    const galleryKey = eventKey || this.state.galleryKey;
    const {
      companyAuthToken,
      v3Order: { orders },
    } = this.props;

    const v3CartContainsPostEventOrders =
      cartUtils.cartContainsPostEventOrders(orders);

    // TODO: implement this
    // const v3CartContainsSeniorsOrders =

    if (galleryKey) {
      const that = this;

      const data = {
        shoot_key: galleryKey,
        company_auth_token: companyAuthToken,
      };

      console.log('KEY TO LOOK UP: ', data);
      console.log(this.state);
      console.log(this.props);

      this.props.getBnlKeyLookup(data).then((resp) => {
        if (resp.payload.data) {
          // Redirect to registration if event has registration enabled
          if (resp.payload.data.has_registration) {
            const eventKey =
              resp.payload.data.shoot_key || this.state.galleryKey;
            Cookies.remove('pics_event_key');
            sessionStorage.removeItem('dashboard_gallery_key');
            this.props.history.push(
              `/events/${eventKey.toUpperCase()}/register`,
            );
            return;
          }

          // Handle mixed registration + ordering events
          if (resp.payload.data.mixed_events) {
            this.showEventTypeDecisionModal(resp.payload.data);
            return;
          }

          // Handle GPI decision modal for retake scenarios
          if (resp.payload.data.decision_required) {
            this.setState({
              keyLookupData: data,
            });
            this.showGpiDecisionModal(resp.payload.data);
            return;
          }

          // TEMPORARY: Cross-company redirect for BNL → G&B (printed flyer had wrong URL).
          // Remove this block after ~March/April 2026.
          if (resp.payload.data.cross_company_redirect) {
            Swal.fire({
              title: 'Different Ordering Site',
              html: `<p>It looks like your event is on the <strong>${resp.payload.data.redirect_company_name}</strong> ordering site.</p><p>Would you like to go there now? Your prepay code will be pre-filled.</p>`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, go to Grynn & Barrett',
              cancelButtonText: 'Cancel',
              confirmButtonColor: '#3085d6',
              didOpen: (popup) => {
                const actions = popup.querySelector('.swal2-actions');
                actions.style.flexDirection = 'column';
                actions.style.gap = '16px';
              },
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = resp.payload.data.redirect_url;
              }
            });
            return;
          }

          if (!resp.payload.data.errors) {
            if (resp.payload.data.pre_shoot && v3CartContainsPostEventOrders) {
              Swal.fire({
                title: 'Your cart contains gallery-based orders',
                html: '<p>Your cart contains gallery-based orders, which cannot be submitted with prepay orders.</p><p>Please submit or clear your gallery-based orders to enable prepay ordering.</p>',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Okay',
              });

              Sentry.captureMessage(
                'v3 gallery-based order in progress warning from dashboard',
              );

              return;
            }

            if (
              that.props.bnlPreShoot.preShoot !== null &&
              !that.props.bnlPreShoot.preShoot &&
              resp.payload.data.pre_shoot
            ) {
              Swal.fire(
                'Gallery based order in progress',
                "Please complete your gallery based order(s). Gallery based ordering and pre-event ordering cannot be completed together. If you'd like to start a different order, please empty your cart and return to the dashboard.",
              );
            } else {
              that.props.setAdditionalData({
                primaryPreviewImageUrl:
                  resp.payload.data.primary_preview_image_url,
                eventCategory: resp.payload.data.event_category,
                keySubmittedByUser: resp.payload.data.key_submitted_by_user,
                picsGalleryId: resp.payload.data.pics_gallery_id ?? null,
                picsGalleryPassword: resp.payload.data.gallery_password || null,
                eventType: resp.payload.data.event_type,
                subjectName: resp.payload.data.subject_name,
                // Clear stale gallery/pose data from previous orders
                allAvailablePosesForOrder: [],
                availablePoses: [],
                availableGroupImages: [],
                galleryThatInitiatedOrder: null,
                studentGallery: [],
                studentGroupImages: [],
                studentPreviewImageUrl: null,
              });
              that.props.setBnlPreShoot(resp.payload.data.pre_shoot);
              that.props.setEnteredKeyIsPrepay(resp.payload.data.pre_shoot);

              sessionStorage.removeItem('dashboard_gallery_key');

              if (that.props.parent.students.length === 0) {
                that.props.history.push('/add-student');
              } else {
                that.props.history.push('/select-student');
              }
            }
          } else {
            Swal.fire({
              title: 'Notice',
              html: resp.payload.data.errors.shootKeyForm,
              icon: 'warning',
            });
          }
        }
      });
    } else {
      Swal.fire('Please fill in your unique Prepay Code or Gallery Password');
    }
  }

  escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  showEventTypeDecisionModal(data) {
    const { registration_events, shoot_key } = data;
    const eventKey = shoot_key || this.state.galleryKey;

    let registerHtml = `
      <div style="text-align: left; margin-bottom: 24px;">
        <h4 style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">
          Register for Picture Day
        </h4>
        <p style="color: #666; font-size: 14px; margin-bottom: 12px;">
          Let your photographer know your student will be attending.
        </p>
        <div class="list-group">
          ${registration_events
            .map(
              (e) => `
            <a href="#" class="list-group-item list-group-item-action mixed-register-option" data-event-id="${
              e.id
            }">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div style="font-weight: 600;">${this.escapeHtml(e.name)}${
                e.is_retake ? ' (Retake)' : ''
              }</div>
                  ${
                    e.venue_name
                      ? `<div style="color: #666; font-size: 13px;">${this.escapeHtml(
                          e.venue_name,
                        )}</div>`
                      : ''
                  }
                  ${
                    e.shoot_date
                      ? `<div style="color: #666; font-size: 13px;">${this.escapeHtml(
                          e.shoot_date,
                        )}</div>`
                      : ''
                  }
                </div>
                <span class="badge badge-primary" style="background-color: #1a73e8;">Register</span>
              </div>
            </a>
          `,
            )
            .join('')}
        </div>
      </div>
    `;

    let orderHtml = `
      <div style="text-align: left;">
        <h4 style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">
          Place an Order
        </h4>
        <p style="color: #666; font-size: 14px; margin-bottom: 12px;">
          Order photos for this event.
        </p>
        <button class="btn btn-outline-dark mixed-order-btn" style="width: 100%; padding: 12px; font-weight: 500;">
          Start Order
        </button>
      </div>
    `;

    Swal.fire({
      title: 'What would you like to do?',
      html: registerHtml + orderHtml,
      width: '500px',
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        document.querySelectorAll('.mixed-register-option').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            Swal.close();
            Cookies.remove('pics_event_key');
            this.props.history.push(
              `/events/${eventKey.toUpperCase()}/register`,
            );
          });
        });

        document.querySelectorAll('.mixed-order-btn').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            Swal.close();
            this.goToStudentSelectionSkipRegistration();
          });
        });
      },
    });
  }

  goToStudentSelectionSkipRegistration() {
    const galleryKey = this.state.galleryKey;
    const {
      companyAuthToken,
      v3Order: { orders },
    } = this.props;

    const v3CartContainsPostEventOrders =
      cartUtils.cartContainsPostEventOrders(orders);

    if (galleryKey) {
      const that = this;

      const data = {
        shoot_key: galleryKey,
        company_auth_token: companyAuthToken,
        skip_registration: 'true',
      };

      this.props.getBnlKeyLookup(data).then((resp) => {
        if (resp.payload.data) {
          if (!resp.payload.data.errors) {
            if (resp.payload.data.pre_shoot && v3CartContainsPostEventOrders) {
              Swal.fire({
                title: 'Your cart contains gallery-based orders',
                html: '<p>Your cart contains gallery-based orders, which cannot be submitted with prepay orders.</p><p>Please submit or clear your gallery-based orders to enable prepay ordering.</p>',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Okay',
              });
              return;
            }

            that.props.setAdditionalData({
              primaryPreviewImageUrl:
                resp.payload.data.primary_preview_image_url,
              eventCategory: resp.payload.data.event_category,
              keySubmittedByUser: resp.payload.data.key_submitted_by_user,
              picsGalleryId: resp.payload.data.pics_gallery_id ?? null,
              picsGalleryPassword: resp.payload.data.gallery_password || null,
              eventType: resp.payload.data.event_type,
              subjectName: resp.payload.data.subject_name,
            });
            that.props.setBnlPreShoot(resp.payload.data.pre_shoot);
            that.props.setEnteredKeyIsPrepay(resp.payload.data.pre_shoot);

            sessionStorage.removeItem('dashboard_gallery_key');

            if (that.props.parent.students.length === 0) {
              that.props.history.push('/add-student');
            } else {
              that.props.history.push('/select-student');
            }
          } else {
            Swal.fire({
              title: 'Notice',
              html: resp.payload.data.errors.shootKeyForm,
              icon: 'warning',
            });
          }
        }
      });
    }
  }

  showGpiDecisionModal(decisionData) {
    const { options } = decisionData;
    const prepayShoots = options?.prepay_shoots || [];
    const galleries = options?.galleries || [];

    // Split prepay shoots into registration and non-registration groups
    const registrationShoots = prepayShoots.filter((s) => s.has_registration);
    const orderableShoots = prepayShoots.filter((s) => !s.has_registration);

    // Build HTML for registration events
    let registrationHtml = '';
    if (registrationShoots.length > 0) {
      registrationHtml = `
        <div style="text-align: left; margin-bottom: 24px;">
          <h4 style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">
            📋 Register for this Event
          </h4>
          <p style="color: #666; font-size: 14px; margin-bottom: 12px;">
            Let your photographer know your student will be attending.
          </p>
          <div class="list-group">
            ${registrationShoots
              .map(
                (s) => `
              <a href="#" class="list-group-item list-group-item-action gpi-register-option" data-shoot-id="${
                s.id
              }" data-shoot-key="${s.key}">
                <div class="decision-card__row">
                  <div class="decision-card__details">
                    <div style="font-weight: 600;">${s.name} ${
                  s.is_retake ? '↩️' : ''
                }</div>
                    <div style="color: #666; font-size: 13px;">${s.shoot_date}${
                  s.date_range_end ? ` – ${s.date_range_end}` : ''
                }</div>
                    ${
                      s.is_retake
                        ? '<div style="color: #007bff; font-size: 12px; margin-top: 4px;">Retake Event</div>'
                        : ''
                    }
                  </div>
                  <span class="badge badge-primary decision-card__badge" style="background-color: #1a73e8; padding-right: 14px;">Register</span>
                </div>
              </a>
            `,
              )
              .join('')}
          </div>
        </div>
      `;
    }

    // Build HTML for prepay events (non-registration)
    let prepayHtml = '';
    if (orderableShoots.length > 0) {
      prepayHtml = `
        <div style="text-align: left; margin-bottom: 24px;">
          <h4 style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">
            📸 Place a Prepay Order
          </h4>
          <p style="color: #666; font-size: 14px; margin-bottom: 12px;">
            Order now before picture day! Choose your photo packages in advance.
          </p>
          <div class="list-group">
            ${orderableShoots
              .map(
                (s) => `
              <div class="list-group-item gpi-prepay-card" data-shoot-id="${
                s.id
              }">
                <div class="decision-card__row" style="margin-bottom: 12px;">
                  <div class="decision-card__details">
                    <div style="font-weight: 600;">${s.name} ${
                  s.is_retake ? '↩️' : ''
                }</div>
                    <div style="color: #666; font-size: 13px;">${s.shoot_date}${
                  s.date_range_end ? ` – ${s.date_range_end}` : ''
                }</div>
                    ${
                      s.is_retake
                        ? '<div style="color: #007bff; font-size: 12px; margin-top: 4px;">Retake Event</div>'
                        : ''
                    }
                  </div>
                  <span class="badge badge-primary decision-card__badge" style="background-color: #007bff; padding-right: 14px;">Prepay</span>
                  <div class="decision-card__media">${seasonTileHtml(
                    s.shoot_date,
                  )}</div>
                </div>
                <button
                  class="gpi-prepay-option"
                  data-shoot-id="${s.id}"
                  data-shoot-name="${s.name}"
                  style="${PREPAY_BUTTON_STYLE}"
                  ${PREPAY_BUTTON_HOVER}
                >
                  Place Your Prepay Order
                </button>
              </div>
            `,
              )
              .join('')}
          </div>
        </div>
      `;
    }

    // Build HTML for galleries
    let galleriesHtml = '';
    if (galleries.length > 0) {
      galleriesHtml = `
        <div style="text-align: left;">
          <h4 style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">
            🖼️ Order From a Gallery
          </h4>
          <p style="color: #666; font-size: 14px; margin-bottom: 12px;">
            View and order from your student's galleries.
          </p>
          <div class="list-group">
            ${galleries
              .map(
                (g) => `
              <div class="list-group-item gpi-gallery-card" data-gallery-id="${
                g.id
              }">
                <div class="decision-card__row" style="margin-bottom: ${
                  g.already_associated ? '12px' : '0'
                };">
                  <div class="decision-card__details">
                    <div style="font-weight: 600;">${
                      g.event_name || 'Gallery'
                    }</div>
                  </div>
                  <span class="badge decision-card__badge ${
                    g.already_associated ? 'badge-success' : 'badge-secondary'
                  }">${
                  g.already_associated ? '✓ On Dashboard' : 'Gallery'
                }</span>
                  <div class="decision-card__media">${
                    g.primary_preview_image_url
                      ? `<img src="${g.primary_preview_image_url}" style="max-width: 100px; border-radius: 4px;" />`
                      : '<div style="color: #999; font-size: 13px;">Images coming soon</div>'
                  }</div>
                </div>
                ${
                  g.already_associated
                    ? `
                  <button
                    class="gpi-gallery-order-btn"
                    data-gallery-id="${g.id}"
                    data-gallery-key="${g.key}"
                    data-event-name="${g.event_name || 'Gallery'}"
                    style="${DECISION_MODAL_BUTTON_STYLE}"
                    ${DECISION_MODAL_BUTTON_HOVER}
                  >
                    🛒 Order from this Gallery
                  </button>
                `
                    : `
                  <button
                    class="gpi-gallery-add-btn"
                    data-gallery-id="${g.id}"
                    data-gallery-key="${g.key}"
                    data-event-name="${g.event_name || 'Gallery'}"
                    style="${DECISION_MODAL_BUTTON_STYLE}"
                    ${DECISION_MODAL_BUTTON_HOVER}
                  >
                    ➕ Add to Dashboard
                  </button>
                `
                }
              </div>
            `,
              )
              .join('')}
          </div>
        </div>
      `;
    }

    Swal.fire({
      title: 'What would you like to do?',
      html: registrationHtml + prepayHtml + galleriesHtml,
      width: '600px',
      showConfirmButton: false,
      showCloseButton: true,
      customClass: { container: 'gpi-dash-swal-container' },
      didOpen: () => {
        // Attach click handlers for registration events
        document.querySelectorAll('.gpi-register-option').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const shootKey = el.getAttribute('data-shoot-key');
            Swal.close();
            Cookies.remove('pics_event_key');
            sessionStorage.removeItem('dashboard_gallery_key');
            this.props.history.push(
              `/events/${shootKey.toUpperCase()}/register`,
            );
          });
        });

        // Attach click handlers for prepay events
        document.querySelectorAll('.gpi-prepay-option').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const shootId = parseInt(el.getAttribute('data-shoot-id'));
            const shoot = orderableShoots.find((s) => s.id === shootId);
            if (shoot) {
              Swal.close();
              this.handleGpiSelectPrepayEvent(shoot);
            }
          });
        });

        // Attach click handlers for "Add to Dashboard" buttons
        document.querySelectorAll('.gpi-gallery-add-btn').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const galleryId = parseInt(el.getAttribute('data-gallery-id'));
            const galleryKey = el.getAttribute('data-gallery-key');
            const gallery = galleries.find((g) => g.id === galleryId);
            if (gallery) {
              Swal.close();
              this.handleGpiAddGalleryToDashboard(gallery, galleryKey);
            }
          });
        });

        // Attach click handlers for "Order from this Gallery" buttons
        document.querySelectorAll('.gpi-gallery-order-btn').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const galleryId = parseInt(el.getAttribute('data-gallery-id'));
            const galleryKey = el.getAttribute('data-gallery-key');
            const gallery = galleries.find((g) => g.id === galleryId);
            if (gallery) {
              Swal.close();
              this.handleGpiOrderFromGallery(gallery, galleryKey);
            }
          });
        });
      },
    });
  }

  handleGpiSelectPrepayEvent(shoot) {
    const that = this;
    const { keyLookupData } = this.state;

    // Resubmit lookup with selected event ID
    this.props
      .getBnlKeyLookupWithSelectedEvent(keyLookupData, shoot.id)
      .then((resp) => {
        if (resp.payload.data && !resp.payload.data.errors) {
          // Handle success - same as normal key lookup flow
          that.props.setAdditionalData({
            primaryPreviewImageUrl: resp.payload.data.primary_preview_image_url,
            eventCategory: resp.payload.data.event_category,
            keySubmittedByUser: resp.payload.data.key_submitted_by_user,
            picsGalleryId: resp.payload.data.pics_gallery_id ?? null,
            picsGalleryPassword: resp.payload.data.gallery_password || null,
            eventType: resp.payload.data.event_type,
            subjectName: resp.payload.data.subject_name,
          });
          that.props.setBnlPreShoot(resp.payload.data.pre_shoot);
          that.props.setEnteredKeyIsPrepay(resp.payload.data.pre_shoot);

          if (that.props.parent.students.length === 0) {
            that.props.history.push('/add-student');
          } else {
            that.props.history.push('/select-student');
          }
        } else {
          Swal.fire({
            title: 'Error',
            html:
              resp.payload.data?.errors?.shootKeyForm ||
              'Unable to access selected event',
            icon: 'error',
          });
        }
      });
  }

  handleGpiAddGalleryToDashboard(gallery, galleryKey) {
    // Gallery not yet associated - trigger normal gallery add flow
    const that = this;
    const { keyLookupData } = this.state;

    that.props
      .getBnlKeyLookupWithSelectedGallery(keyLookupData, gallery.id)
      .then((resp) => {
        if (resp.payload.data && !resp.payload.data.errors) {
          // Store the response and navigate to student selection
          that.props.setAdditionalData({
            primaryPreviewImageUrl: resp.payload.data.primary_preview_image_url,
            eventCategory: resp.payload.data.event_category,
            keySubmittedByUser: resp.payload.data.key_submitted_by_user,
            picsGalleryId: resp.payload.data.pics_gallery_id,
            picsGalleryPassword: resp.payload.data.gallery_password || null,
            subjectName: resp.payload.data.subject_name,
          });
          that.props.setEnteredKeyIsPrepay(false); // Tell student selection to use gallery flow, not prepay flow
          that.props.history.push('/select-student');
        } else {
          Swal.fire({
            title: 'Error',
            html:
              resp.payload.data?.errors?.shootKeyForm ||
              'Unable to load gallery',
            icon: 'error',
          });
        }
      });
  }

  async handleGpiOrderFromGallery(gallery, galleryKey) {
    // Gallery is already on dashboard - set up order flow
    const { keyLookupData } = this.state;

    // Show loading spinner
    this.setState({ loading: true });
    this.props.setEnteredKeyIsPrepay(false);

    try {
      const resp = await this.props.getBnlKeyLookupWithSelectedGallery(
        keyLookupData,
        gallery.id,
      );

      if (resp.payload.data && !resp.payload.data.errors) {
        const responseData = resp.payload.data;

        // Check if gallery is associated with exactly 1 student
        if (
          gallery.associated_student_ids &&
          gallery.associated_student_ids.length === 1
        ) {
          // Auto-select the student and go directly to order (same as dashboard)
          const studentId = gallery.associated_student_ids[0];
          const student = this.props.parent.students.find(
            (candidate) => String(candidate.id) === String(studentId),
          );

          if (student) {
            const dashboardResponse = await axios.get('/api/v2/dashboard');
            const dashboardData = dashboardResponse.data;
            const selectedGallery = findDashboardGalleryForOrder(
              dashboardData,
              student.id,
              gallery.id,
            );

            if (!selectedGallery) {
              this.setState({ loading: false });
              Swal.fire({
                title: 'Gallery unavailable',
                html: 'This gallery is no longer available on your dashboard. Please refresh the page and try again.',
                icon: 'error',
              });
              return;
            }

            const galleryOrderContext = buildGalleryOrderContext({
              dashboardData,
              gallery: selectedGallery,
              student,
            });
            const data = buildGalleryOrderShootData({
              student,
              gallery: selectedGallery,
              shootKey: galleryKey,
            });

            this.props.setBnlPreShoot(false);

            const shootResp = await this.props.getShootData(data);
            if (shootResp.payload.data.errors) {
              this.setState({ loading: false });
              Swal.fire({
                title: 'Error',
                html:
                  shootResp.payload.data?.errors?.shootKeyForm ||
                  'Unable to load gallery data',
                icon: 'error',
              });
              return;
            }

            const shootData = shootResp.payload.data;

            // Format and set products (same as dashboard)
            this.formatBackgroundOptions(
              shootData.contains_background_categories,
              shootData.background_options,
            );
            this.formatIncentiveProducts(shootData.incentive_products);

            this.props.setRetouchingProduct(shootData.retouching_product);
            this.props.setRetouchingProducts(shootData.retouching_products);
            this.props.setPersonalizationProduct(
              shootData.personalization_product,
            );
            this.props.setInterstitialProducts(shootData.interstitial_products);
            this.props.setPreCartOfferProducts(
              shootData.pre_cart_offer_products,
            );
            this.props.setTriggersPreCartOfferProducts(
              shootData.triggers_pre_cart_offer_products,
            );

            this.props.setAdditionalData({
              ...galleryOrderContext,
              primaryPreviewImageUrl: responseData.primary_preview_image_url,
              eventCategory: responseData.event_category,
              keySubmittedByUser:
                responseData.key_submitted_by_user || galleryKey,
              eventType: responseData.event_type,
              subjectName: responseData.subject_name,
            });

            this.setState({ loading: false });
            this.props.history.push('/v3/incentive-offers');
            return;
          }
        }

        // Fallback: No student or multiple students - go to student selection
        this.props.setBnlPreShootOrderContext({
          galleryPassword: galleryKey,
          shootKey: galleryKey,
          shootId: responseData.shoot_id || gallery.event_id,
          shootName: responseData.shoot_name,
        });

        this.props.setAdditionalData({
          primaryPreviewImageUrl: responseData.primary_preview_image_url,
          eventCategory: responseData.event_category,
          keySubmittedByUser: galleryKey,
          // Always set both id and password: setAdditionalData is a shallow
          // merge over persisted state, so omitting one would leave a stale
          // id/password pair from an earlier lookup in place
          picsGalleryId: responseData.pics_gallery_id || gallery.id,
          picsGalleryPassword: responseData.gallery_password || galleryKey,
          eventType: responseData.event_type,
          subjectName: responseData.subject_name,
        });

        this.setState({ loading: false });
        this.props.history.push('/select-student');
      } else {
        this.setState({ loading: false });
        Swal.fire({
          title: 'Error',
          html:
            resp.payload.data?.errors?.shootKeyForm || 'Unable to load gallery',
          icon: 'error',
        });
      }
    } catch (_error) {
      this.setState({ loading: false });
      Swal.fire({
        title: 'Error',
        html: 'Unable to load gallery',
        icon: 'error',
      });
    }
  }

  renderStudents() {
    if (this.props.parent.students.length > 0) {
      const students = this.props.parent.students.map((student) => (
        <li
          className="bnl-dashboard__my-students__student"
          key={`dashboard-student-${student.id}`}
        >
          {student.firstName} {student.lastName}
        </li>
      ));
      return (
        <ul className="bnl-dashboard__my-students__container">{students}</ul>
      );
    }

    return (
      <div className="bnl-dashboard__my-students__container">
        <div className="bnl-dashboard__my-students__no-student-header">
          You currently have no students to display.
        </div>
        <div className="bnl-dashboard__my-students__no-student-subheader">
          Enter your unique code or gallery password above to add students and
          start an order.
        </div>
      </div>
    );
  }

  render() {
    const { auth, companyName, eventLookupByZipcodeEnabled, history } =
      this.props;
    // prevent from rendering until redux retrieves current user
    if (
      auth.currentUserId === null &&
      auth.signupCompleted === null &&
      !this.props.parent
    ) {
      return <div id="loading" />;
    }

    const loading = this.state.loading ? 'loading' : 'hidden';

    // if (requiresTermsConditions) {
    //   return <Redirect to="/v3/terms-conditions" />;
    // }

    return (
      <div className="bnl-dashboard-container">
        <div className={loading}>
          <div className="spinner" />
        </div>
        {/* <h4 className="bnl-dashboard-container__header">My Dashboard</h4> */}
        <div className="bnl-dashboard">
          <BnlDashboardNotice {...this.props} />
          <UnsubscribeBanner />
          <div className="page-header">
            <h1>Start a New Order</h1>
          </div>
          <div className="alert alert-info alert-dismissible" role="alert">
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            To start a new order, please enter your student&apos;s Prepay Code
            or Gallery Password below and click &quot;Start Order.&quot;
          </div>
          <BnlParentGalleryKeyForm
            galleryKey={this.state.galleryKey}
            goToStudentSelection={this.goToStudentSelection}
            handleKeyPress={this.handleKeyPress}
            handleOnChange={this.handleOnChange}
            companyName={companyName}
            presetEventKey={this.state.presetEventKey}
            eventLookupByZipcodeEnabled={eventLookupByZipcodeEnabled}
          />
          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <MyRegistrations compact />
          </div>
          <div className="page-header">
            <h1>Portrait Galleries</h1>
          </div>
          <div className="alert alert-warning alert-dismissible" role="alert">
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            The area below is where your portraits will be stored{' '}
            <strong>AFTER</strong> picture day. Portraits will not automatically
            appear until you add them to your account.
          </div>
          <DashboardGalleries history={history} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    additionalData: state.additionalData,
    auth: state.auth,
    bnlPreShoot: state.bnlPreShoot,
    cart: state.cart,
    gallery: state.gallery,
    parent: state.parent,
    orderNavigation: state.orderNavigation,
    reducerHistory: state.reducerHistory,
    shoot: state.shoot,
    v3Order: state.v3Order,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStudents,
      formatAndSetBackgroundOptions,
      formatAndSetIncentiveProducts,
      setInterstitialProducts,
      setPreCartOfferProducts,
      getBnlKeyLookup,
      getBnlKeyLookupWithSelectedEvent,
      getBnlKeyLookupWithSelectedGallery,
      getGalleries,
      getShootData,
      setAdditionalData,
      setBnlPreShoot,
      setBnlPreShootOrderContext,
      setEnteredKeyIsPrepay,
      setRetouchingProduct,
      setRetouchingProducts,
      setPersonalizationProduct,
      setTriggersPreCartOfferProducts,
      storeOrder,
      updateOrderActiveComponent,
    },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BnlParentDashboard),
);
